import { useCallback, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import Trivia from "../components/Trivia";
import Video from "../components/Video";
import TapArea from "../components/TapArea";
import { AudioContext } from "../AudioContext";

import styles from "./AthleteTrivia.module.css";


const AthleteTrivia = ({athlete_name, closet_path, video_path, question_id, choices, question, message}) => {
  const [showTrivia, setshowTrivia] = useState(false);
  const { muted, setMuted } = useContext(AudioContext);
  const videoRef = useRef(null);

  const onClickShowTrivia = () => {
    setshowTrivia(true);
  };

  const navigate = useNavigate();
  
  const checkoutCloset = useCallback(() => {
    navigate(closet_path);
  }, [navigate]);


  const previousPage = useCallback(() => {
    navigate("/who-best");
  }, [navigate]);

  const handleMuteToggle = () => {
    setMuted((prev) => {
      const newMuted = !prev;
      if (videoRef.current) {
        videoRef.current.muted = newMuted;
      }
      return newMuted;
    });
  };

  return (
    <div className={styles.athleteTrivia}>
      <TapArea style={styles.leftNav} onClick={previousPage} />
      <TapArea style={styles.rightNav} onClick={checkoutCloset} />

      <ProgressBar current='2' />

      <div className={styles.player}>

        <div className={styles.gradient}></div>

        <video
          ref={videoRef}
          muted={muted}
          autoPlay
          playsInline
          loop
          src={video_path}
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover'
          }}
        />
      </div>

      {!showTrivia
        ?
        <>
          <div className={styles.questionButton} onClick={onClickShowTrivia}>
            <img className= {styles.statIcon} src={'stat.svg'} />
            <div className= {styles.question}  >
              How well do you know {athlete_name}?
            </div
            >
          </div>
        </>
        :
        <>
          <div className={styles.frameParent}>
            <Trivia
              question={question}
              choices={choices}
              question_id={question_id}
              info={message}
              athlete={athlete_name}
            />
          </div>
          <div className={styles.checkoutButton} onClick={checkoutCloset} >
            <div className= {styles.question} >
              Check out {athlete_name}'s Closet ➔
            </div>
          </div>
        </>
        }
      <button
        className={styles.muteButton}
        onClick={handleMuteToggle}
        aria-label={muted ? "Unmute video" : "Mute video"}
      >
        {muted ? (
          // Mute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
        ) : (
          // Unmute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19 12c0-1.77-.77-3.29-2-4.29M19 12c0 1.77-.77 3.29-2 4.29M15 8.71V15.3"></path></svg>
        )}
      </button>

    </div>
  )
}
export default AthleteTrivia;
